;(function () {
  if (!document.body || !document.body.classList) return
  var bodyClass = document.body.className || ''
  if (!/template-product-ir-inositol/.test(bodyClass)) return
  if (window.__IR_UGC_HEADER_RATING__) return
  window.__IR_UGC_HEADER_RATING__ = true

  var UGC_TITLE = 'Customer Feedback You Can Trust'

  function buildRatingRow() {
    var row = document.createElement('div')
    row.className = 'ir-ugc-rating'
    row.setAttribute('aria-label', 'Product rating')
    row.setAttribute('data-ir-dynamic-section-rating', '')
    row.innerHTML =
      '<div class="ir-ugc-stars" aria-hidden="true" data-ir-stars></div>' +
      '<div class="ir-ugc-rating-text rte" data-ir-text></div>'
    return row
  }

  function buildTitleBlock() {
    var wrapper = document.createElement('div')
    wrapper.className = 'cevoid-title-wrapper'
    wrapper.setAttribute('data-ir-ugc-done', '1')
    wrapper.innerHTML =
      '<span class="ir-ugc-title-line ir-ugc-title-line--main">' +
      'Customer Feedback ' +
      '<span class="ir-ugc-title-accent">You Can Trust</span>' +
      '</span>'
    wrapper.appendChild(buildRatingRow())
    return wrapper
  }

  function norm(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim()
  }

  function ensureCevoidHeader() {
    var wrappers = document.querySelectorAll('.cevoid-title-wrapper, [class*="cevoid-title-wrapper"]')
    if (!wrappers || !wrappers.length) return

    for (var h = 0; h < wrappers.length; h++) {
      var wrapper = wrappers[h]
      if (wrapper.getAttribute('data-ir-ugc-done')) {
        continue
      }

      var fullText = norm(wrapper.textContent || '')
      if (fullText.indexOf(UGC_TITLE) === -1) continue

      wrapper.innerHTML =
        '<span class="ir-ugc-title-line ir-ugc-title-line--main">' +
        'Customer Feedback ' +
        '<span class="ir-ugc-title-accent">You Can Trust</span>' +
        '</span>'

      wrapper.appendChild(buildRatingRow())

      wrapper.setAttribute('data-ir-ugc-done', '1')
    }
  }

  function ensureStampedReviewsHeader() {
    var widget = document.getElementById('stamped-main-widget')
    if (!widget) {
      widget = document.querySelector('div.stamped-main-widget')
    }
    if (!widget || widget.nodeType !== 1) return
    var prev = widget.previousElementSibling
    if (prev && prev.classList && prev.classList.contains('cevoid-title-wrapper') && prev.getAttribute('data-ir-ugc-done') === '1') {
      return
    }
    var host = widget.parentElement
    if (!host) return
    host.insertBefore(buildTitleBlock(), widget)
  }

  function run() {
    ensureCevoidHeader()
    ensureStampedReviewsHeader()
  }

  function init() {
    run()

    try {
      new MutationObserver(function () {
        run()
      }).observe(document.body, { childList: true, subtree: true })
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
